import { styled } from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

export const Content = styled(Stack)`
    gap: 16px;
    position: relative;
`;
